
// export const IP =  'https://zhuanzhen.huayiyun.net:8888/admin-api' //正式地址
// export const IP =  'http://192.168.2.83:9000' //本地
export const IP =  'https://demo-zhuanzhen.huayiyun.net:8082/zhuanzhen-admin-api' //demo地址

const domain={
    getImageCode:IP+'/getImageCode',//获取图形验证码
    
    login:IP+'/login',//登录
    logout:IP+'/logout',//退出登录
    listHospRank:IP+'/base/listHospRank', //获取医院等级列表
    listRegion:IP+'/base/listRegion',//获取地址（五级联动）

    //医院管理
    listHosp:IP+'/hosp/list', //获取所有医院列表
    addHosp:IP+'/hosp/add', //新增医院
    updateHosp:IP+'/hosp/update', //修改医院信息
    getHospDetail:IP+'/hosp/get',//查询医院详情
    deleteHosp:IP+'/hosp/delete',//删除医院

    //上级医院管理
    listParentHosp:IP+'/parentHosp/list', //获取上级医院列表
    addParentHosp:IP+'/parentHosp/add', //添加上级医院
    disbaleParent:IP+'/parentHosp/disbale', //禁用上级医院
    notAssignedList:IP+'/parentHosp/listUnBind', //获取未绑定医院列表

    //管理员
    addHospAdmin:IP+'/admin/create', //创建医院管理员
    resetAdminPwd:IP+'/admin/resetPwd', //重置医院管理员密码
    getAdmin:IP+'/admin/get', //查询医院管理员信息

    //医生管理
    queryRoleList:IP+'/admin/queryRoleList',//查询所有角色列表
    openAccount:IP+'/admin/openAccount',//医生开户
    queryUserFromHosp:IP+'/admin/queryUserFromHosp',//查询医生列表
    queryUserInfo:IP+'/admin/queryUserInfo',//查询医生用户信息
    updateUserInfo:IP+'/admin/updateUserInfo',//更新医生用户信息

    //病历统计和数据统计
    caseList:IP+'/case/list',//病例列表
    caseDetail:IP+'/case/get',//病例详情
    countByEmergRate:IP+'/case/countByEmergRate',//查询急诊率的病例数
    countByGender:IP+'/case/countByGender',//查询病人性别的病例数
    countByAge:IP+'/case/countByAge',//查询病人年龄段的病例数
    countBySatatus:IP+'/case/countBySatatus',//查询病例状态的病例数
    countByExpense:IP+'/case/countByExpense',//查询报销类型的病例数
    countByPurpose:IP+'/case/countByPurpose',//查询转诊目的的病例数
    exportCaseStatistics:IP+'/case/exportCaseStatistics',//导出
    
    listByRegion:IP+'/hosp/listByRegion',///根据地区获取医院

    regionList:IP+'/regionData/list',
    regionAdd:IP+'/regionData/add',
    regionUpdate:IP+'/regionData/update',
    regionDelete:IP+'/regionData/delete',

    listLogUser:IP+'/log/list',
    
}


export default domain



// WEBPACK FOOTER //
// ./src/service/getDate.js